import React from 'react'
import { useDispatch } from 'react-redux'

import { changeGlobalMenu } from 'store/actions/ui.action'
import { IconButton } from '@mui/material'
import AppsIcon from '@mui/icons-material/Apps'
import { useAppSelector } from 'store/useStoreHook'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'

const GlobalMenuButton = ({
    size,
}: {
    size?: 'large' | 'small' | 'medium'
}) => {
    const isOpen = useAppSelector((state) => state.ui.globalMenu.isOpen)
    const dispatch = useDispatch()
    const { IsSmallerThanSpecified } = useScreenSize(1277)

    const toggleMenu = (event: any) => {
        event.stopPropagation()
        dispatch(changeGlobalMenu(!isOpen))
    }

    return (
        <IconButton
            data-testid={'btnAppbar'}
            color="inherit"
            onClick={toggleMenu}
            size={size === 'small' ? 'small' : 'large'}
            sx={{
                padding: IsSmallerThanSpecified ? '6px' : undefined,
            }}
        >
            <AppsIcon
                sx={{
                    fontSize:
                        size === 'large' ? 56 : size === 'small' ? 24 : 36,
                }}
            />
        </IconButton>
    )
}

export default GlobalMenuButton
